(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('styledDropdown', {
            templateUrl: 'app/components/styled-dropdown/styled-dropdown.html',
            controller: styledDropdownController,
            bindings: {
                labelKey: '@',
                name: '@',
                options: '<',
                readonly: "<",
                placeholder: '@',
                onToggle: '&'
            }
        });

    /** @ngInject */
    function styledDropdownController() {

        var $ctrl = this;

        $ctrl.hasCondition = function(option) {
            if (angular.isUndefined(option.condition)) {
                return true;
            }
            return option.condition;
        };
    }
})();
